import { getClientsApi } from '../generated/clients/getClients';

import { getClientDetailsApi } from './getClientDetails';

const clientsApi = getClientsApi.enhanceEndpoints({
  endpoints: {
    getClients: {
      forceRefetch: ({ currentArg, previousArg }) => currentArg?.page !== previousArg?.page,
      merge: (currentCache, newData, { arg }) => {
        if (arg?.page == null || arg.page === 1) {
          return newData;
        }

        return {
          ...newData,
          data: [...currentCache.data, ...newData.data],
        };
      },
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        for (const client of data.data) {
          dispatch(getClientDetailsApi.util.upsertQueryData('getClientDetails', { clientId: client._id }, client));
        }
      },
      providesTags: (result) =>
        result?.data ?
          [
            ...result.data.map(({ _id: id }) => ({ id, type: 'Clients' as const })),
            { id: 'LIST', type: 'Clients' as const },
          ]
        : [{ id: 'LIST', type: 'Clients' as const }],
      serializeQueryArgs: ({ queryArgs }) => {
        const { page, ...rest } = queryArgs ?? {};

        return rest;
      },
    },
  },
});

export const { useLazyGetClientsQuery } = clientsApi;
